import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import styled from "@emotion/styled";

export const StyledDynamicCheckbox = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const StyledDynamicCheckboxSpan = styled("span")({
  fontSize: "14px",
  fontWeight: "300",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "5px",
});

export const StyledAsterisk = styled("span")({
  color: "red",
  marginLeft: "2px",
  fontSize: "14px",
});

export const StyledIcon = styled("img")(({ iconWidth }) => ({
  width: iconWidth,
}));

export default function DynamicCheckbox({
  label,
  labelStyle = {},
  checked,
  color = "",
  onChange,
  containerStyle = {},
  name = "",
  iconSrc = null,
  iconWidth = "25px",
  fontSize = "",
  labelId = `${name}`,
  required = false,
  isDarkMode,
}) {
  const handleLabelClick = () => {    
    const event = { target: { name, checked: !checked, type: 'checkbox' } };
    event.persist = () => {};
    onChange(event);
  };

  return (
    <StyledDynamicCheckbox style={containerStyle} className="dynamic-checkbox">
      <Checkbox
        id={labelId}
        checked={checked}
        onChange={onChange}
        inputProps={{ "aria-label": "Checkbox demo" }}
        sx={{
          "& .MuiSvgIcon-root": { fontSize: {fontSize}, color: color ? color : isDarkMode ? "var(--page_Header_Color)" : "var(--header__color)",
          },
        }}
        name={name}
        className="checkbox-div"
      />

      <StyledDynamicCheckboxSpan
        onClick={handleLabelClick}
        style={labelStyle}
        className="checkboxspan"
      >
        {iconSrc && <StyledIcon src={iconSrc} width={iconWidth} alt="icon" />}
        {label}
        {required && <StyledAsterisk>*</StyledAsterisk>}
      </StyledDynamicCheckboxSpan>
    </StyledDynamicCheckbox>
  );
}
